export default {
  CHECK_PRICE: 'checkPrice',
  REQUEST_UNIT_INFORMATION: 'requestUnitInformation',
}
